import AppBrandLogo from 'components/common/AppBrandLogo'

const AuthLayout = ({ children }) => {
  return (
    <div className='font-nunito min-h-screen flex items-center justify-center bg-greenPrimary'>
      <div className='bg-white p-8 rounded-xl shadow-md w-96 flex flex-col items-center'>
        <AppBrandLogo size='lg' className='mb-4' />
        {children}
      </div>
    </div>
  )
}

export default AuthLayout
